export function trimHandler(text, onBlur, onChange) {
    const trimmed = text.trim();
    onChange(trimmed);
    onBlur();
}
